import { faArrowLeftLong } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import CarrotIcon from 'turnip/assets/images/carrot-icon-white.svg?react';
import { dashboardUrl } from 'utils/carrotUrls';

/** Minimal top bar for Call Tracking when opened from account-manager. */
export function SimpleNavBar({ backUrl }: { backUrl: string }) {
  return (
    <nav
      className="exclude-a11y-check h-[50px] bg-orange-500 text-white md:h-[55px]"
      aria-label="General navigation"
    >
      {/* Match the page body width (PageLayoutContained) so the bar's contents
          align to the same left/right edges as the page. */}
      <div className="container mx-auto flex h-full items-center justify-between px-4 sm:px-6 lg:px-8">
        <a href={dashboardUrl} aria-label="Go to dashboard">
          <CarrotIcon className="h-[39px]" aria-hidden />
        </a>

        <a
          href={backUrl}
          className="flex items-center gap-2 whitespace-nowrap font-bold underline-offset-4 hover:underline"
        >
          <FontAwesomeIcon icon={faArrowLeftLong} />
          Back to account
        </a>
      </div>
    </nav>
  );
}
